// Gamme de formats Tartina — données de test EN DUR pour la maquette.
import potRond from '../assets/images/produits/Chevalets-Tartina Best Bestie-01.png';
import potRectangle from '../assets/images/produits/Chevalets-Tartina Best Bestie-02.png';
import potOvale from '../assets/images/produits/Chevalets-Tartina Best Bestie-03.png';
import potPratique from '../assets/images/produits/Sans titre - 1_Plan de travail 1.png';

export const products = [
  {
    id: 'famille',
    name: 'Format Famille',
    size: '750 g',
    tag: 'Best-seller',
    description: "Le format du quotidien, pour toute la famille au petit-déjeuner comme au goûter.",
    image: potRectangle,
  },
  {
    id: 'pratique',
    name: 'Format Pratique',
    size: '400 g',
    tag: 'Idéal à emporter',
    description: 'Compact et facile à transporter, parfait pour les petites cuisines et les pique-niques.',
    image: potPratique,
  },
  {
    id: 'gourmand',
    name: 'Format Gourmand',
    size: '1 kg',
    tag: 'Le plus généreux',
    description: 'Pour les grandes occasions et les amoureux de Tartina qui n\'en ont jamais assez.',
    image: potOvale,
  },
  {
    id: 'pro',
    name: 'Format Professionnel',
    size: '5 kg',
    tag: 'Pâtisseries & boulangeries',
    description: 'Le seau Tartina pensé pour les professionnels : pâtissiers, boulangers, restaurateurs.',
    image: potRond,
  },
];

export default products;
